// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"97cd89b2","293":"9e42ffb3","516":"dbfd8da9","917":"f05dc749","946":"de30c07c"}[chunkId] + ".chunk.js";
};